import React from "react";

export default function Transactions() {
  return (
    <div>
      <h2 className="mb-4">Transactions</h2>
      <div className="card p-3 shadow-sm">
        <p>Transaction table will be displayed here.</p>
      </div>
    </div>
  );
}
